import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import cn from 'classnames'
import moment from 'moment'
import { isInt } from 'helpers/math'
import CircleLoader from 'components/Loading/CircleLoader'

class LineChart extends Component {
  getFormattedChartData = data =>
    data.map(dataItem => {
      const data = {}
      for (const key in dataItem) {
        if (dataItem.hasOwnProperty(key)) {
          if (moment(dataItem[key], 'YYYY-MM-DD', true).isValid()) {
            data.x = dataItem[key]
          } else {
            data.y = dataItem[key]
          }
        }
      }

      return data
    })

  getAxisConfig = () => {
    const { doubleDataset, leftLabel, rightLabel, label } = this.props
    const axes = []

    if (doubleDataset) {
      axes.push({
        display: true,
        position: 'left',
        id: 'leftSide',
        scaleLabel: {
          display: true,
          labelString: leftLabel,
        },
        afterFit: scale => {
          // eslint-disable-next-line no-param-reassign
          scale.width = 85
        },
      })
      axes.push({
        display: true,
        position: 'right',
        id: 'rightSide',
        scaleLabel: {
          display: true,
          labelString: rightLabel,
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
        afterFit: scale => {
          // eslint-disable-next-line no-param-reassign
          scale.width = 60
        },
      })
    } else {
      axes.push({
        display: true,
        scaleLabel: {
          display: true,
          labelString: label,
        },
        afterFit: scale => {
          // eslint-disable-next-line no-param-reassign
          scale.width = 85
        },
      })
    }

    return axes
  }

  chartData = () => {
    const {
      data,
      color,
      label,
      leftLabel,
      rightLabel,
      leftColor,
      rightColor,
      leftData,
      rightData,
      doubleDataset,
    } = this.props
    const defaultParams = {
      fill: false,
      lineTension: 0,
      pointRadius: 6,
      pointHitRadius: 6,
      pointHoverRadius: 6,
    }
    const dataKit = []

    if (doubleDataset && !!leftLabel && !!rightLabel) {
      dataKit.push({
        ...defaultParams,
        yAxisID: 'leftSide',
        label: leftLabel,
        backgroundColor: leftColor,
        borderColor: leftColor,
        data: this.getFormattedChartData(leftData),
      })
      dataKit.push({
        ...defaultParams,
        yAxisID: 'rightSide',
        label: rightLabel,
        backgroundColor: rightColor,
        borderColor: rightColor,
        data: this.getFormattedChartData(rightData),
      })
    } else {
      dataKit.push({
        ...defaultParams,
        label,
        backgroundColor: color,
        borderColor: color,
        data: this.getFormattedChartData(data),
      })
    }

    return {
      datasets: dataKit,
    }
  }

  chartOptions = yAxes => {
    const { color, range, offset, doubleDataset } = this.props
    const tooltipColor = doubleDataset ? {} : { backgroundColor: color }

    return {
      aspectRatio: 5,
      responsive: true,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          right: 10,
        },
      },
      tooltips: {
        ...tooltipColor,
        displayColors: false,
        callbacks: {
          title: tooltip => {
            const value = Number(tooltip[0].value)

            return isInt(value) ? value.toString() : value.toFixed(4)
          },
          label: tooltip => moment(tooltip.xLabel).format('DD-MM-YYYY'),
        },
      },
      scales: {
        xAxes: [
          {
            display: true,
            offset,
            type: 'time',
            time: {
              unit: 'day',
              displayFormats: {
                day: 'DD MM YYYY',
              },
            },
            ticks: {
              min: range.get('startDate').startOf('day'),
              max: range.get('endDate').startOf('day'),
              minRotation: 0.001,
              callback: () => '',
            },
            gridLines: {
              display: true,
              drawBorder: true,
            },
          },
        ],
        yAxes,
      },
      plugins: {
        datalabels: {
          display: false,
        },
      },
    }
  }

  render() {
    const { className, loader, doubleLoader, doubleDataset } = this.props
    const yAxesConfig = this.getAxisConfig()
    const chartHeight = doubleDataset ? 95 : 45
    const loading = doubleDataset ? doubleLoader : loader

    return (
      <div className={cn('line-chart-box', { [className]: className })}>
        <CircleLoader loading={loading} />
        <Line
          width={null}
          height={chartHeight}
          data={this.chartData()}
          options={this.chartOptions(yAxesConfig)}
        />
      </div>
    )
  }
}

LineChart.defaultProps = {
  keyValue: '',
  data: [],
  label: '',
  leftLabel: '',
  rightLabel: '',
  doubleDataset: false,
}

export default LineChart
